import { Card } from "primereact/card";
import { OverlayPanel } from "primereact/overlaypanel";
import React,{ FC } from "react";
import { TawreedFormField, TawreedInputPlain } from "../../../../../../common";
import { DateUtils } from "../../../../../../helpers/date";
import { UserInfo } from "./user-info";

export interface OrderNoteProps{
    salesOrderNoteId: number;
    salesOrderId: number;
    createdAt: Date;
    note: string;
    userId: number;
    userName: string;
    mobileNo: string;
    email: string;
    partner: any
}
export const OrderNote:FC<OrderNoteProps> = (orderNote) =>{

    
    const customer = React.useRef<OverlayPanel>(null);
    return(
        <Card key={orderNote.salesOrderNoteId}>
            <OverlayPanel ref={ customer} style={{ width: '33vw' }} breakpoints={{ '960px': '60vw', '640px': '80vw' }}>
                <UserInfo userName={orderNote.userName} mobileNo={orderNote.mobileNo} email={orderNote.email}
                 partner={orderNote.partner.partnerName}></UserInfo>
                
            </OverlayPanel>
            <div className="formgrid grid">
            <div className="col-6 sm:col-6 md:col-3">
                <TawreedInputPlain value={orderNote.userName} name="userName" render="standalone" mode="text" className="text-primary cursor-pointer" onClick={(e) => customer.current?.toggle(e)} />
            </div>
            <div className="col-6 sm:col-6 md:col-3">
                <TawreedInputPlain name="noteDate" render="standalone" mode="datetime" value={ DateUtils.format(orderNote.createdAt,"datetime")} />
            </div>
            
            </div>
            
            <p className="m-0" style={{whiteSpace:'pre-wrap',overflowWrap: 'break-word', textAlign:'justify'}}>
            {orderNote.note}
            </p>
        </Card>
    );
}